import React from 'react';
import strings from "../config/strings";
import Image from "../components/Image"
import Switch from "../components/Switch"

import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
  FlatList,
  ActivityIndicator,
  Dimensions
} from 'react-native';



const COLORS = ['#ffff00', '#FF6565', '#FFB526', '#A6EF79', '#6AEDFF', '#2BA5F7', '#888', '#000'];

const OPTIONS_HEIGHT = 150

class DrawingOptions extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {color: COLORS[0], transparent:true, selectArea: true, brushSize: 5, expanded: true};
  }
  renderColorItem(item, index) {
    return (
      <TouchableOpacity
        onPress={() => {

          this.props.setColor(item)
          this.setState({color: item, isErasing: false})}

        }
        style={{
          width: 20,
          height: 20,
          margin: 4,
          borderRadius: 10,
          backgroundColor: item,
          justifyContent: 'center',
          alignItems: 'center',
          borderColor: item == this.state.color ? '#fff' : 'transparent',
          borderWidth: 2,
          //opacity: 0.5
        }}
      />
    );
  }

  renderColors() {
    return (
      <FlatList
        data={COLORS}
        renderItem={(item) => this.renderColorItem(item.item, item.index)}
        keyExtractor={(item) => item.item}
        contentContainerStyle={{flexGrow: 0}}
        style={{flexGrow: 0}}
        numColumns={COLORS.length}
      />
    );
  }


  renderCollapsed() {
    return (
      <TouchableOpacity
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 40,
          height: 40,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#2ba5f7',
          borderRadius: 20,
          margin: 20,
          zIndex: 200
        }}
        onPress={() => {
          this.setState({expanded: true})
        }
        }>
        <Image
          urlOnServer={'/imgs/draw_circle_on.png'} 
          style={{width: 25, height: 25}}
        />
      </TouchableOpacity>
    );
  }

  render() {

    if (!this.state.expanded)
      return this.renderCollapsed()
    return (

      <View style={{
            zIndex: 200,
            paddingHorizontal: 20,
            width:'330px',
            backgroundColor: '#aa555555',
            borderBottomRightRadius: 20,
          }}>
        <View
          style={{
            flexDirection:'row',
            alignItems:'center',
            
          }}>
          <Text style={{color: '#fff', minWidth:50}}>{strings.size}:</Text>


          <input 
           style={{width: 80, height: 20, margin: 4}}
           type="range" 
           min="1" 
           max="40" 
           value={this.state.brushSize} 
           onChange={(e) => { 
            this.setState({brushSize: e.target.value})
            this.props.setBrushSize(e.target.value)}}
        />


        <Text style={{marginLeft:8, color:'#fff'}}>{strings.transparent}</Text>

        <View style={{marginTop:6, marginLeft:8}}>
        <Switch
        style={{marginTop:5}}
          trackColor={{ false: "rgba(250,250,250,0.2)", true: "#2ba5f7" }}
          thumbColor={"#D3D3D3"}
          ios_backgroundColor="rgba(250,250,250,0.2)"
          onChange={() => {
            
            this.props.setTransparent(!this.state.transparent)
            this.setState({transparent: !this.state.transparent})}
          
          }
          checked={this.state.transparent}
        />
        </View>
          </View>

          <View
            style={{
              flexDirection: 'row',

              alignItems:'center',
              paddingVertical:4
            }}>
            <Text style={{color: '#fff', minWidth:50}}>
              {strings.color}:
            </Text>
            {this.renderColors()}

            </View>




          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingBottom:16
            }}>

            <TouchableOpacity
                style={{
                  width: 40,
                  height: 40,
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight:4,
                  marginLeft:-8,

                }}
                onPress={() => {
                  this.setState({isErasing:false})
                  this.props.setErasing(false)
                }}>
                <Image
                urlOnServer={!this.state.isErasing ? '/imgs/draw_circle_on.png' : '/imgs/draw_circle_off.png'} 
                 // source={!this.state.isErasing ? require('../imgs/draw_circle_on.png') : require('../imgs/draw_circle_off.png')}
                  style={{width: 25, height: 25}}
                />
              </TouchableOpacity>

              <TouchableOpacity
                style={{
                  width: 40,
                  height: 40,
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginHorizontal:4
                }}
                onPress={() => {
                  this.props.setErasing(!this.state.isErasing)
                  this.setState({isErasing: !this.state.isErasing})}}>
                <Image
                urlOnServer={this.state.isErasing ? '/imgs/eraser_circle.png' : '/imgs/eraser_circle_off.png'} 
                  //source={this.state.isErasing ? require('../imgs/eraser_circle.png') : require('../imgs/eraser_circle_off.png')}
                  style={{width: 25, height: 25}}
                />
              </TouchableOpacity>

         
              <View style={{flex:1}}/>
              <TouchableOpacity
                style={{

                  height: 40,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onPress={() => {
        
                  this.setState({expanded: false})
                }
                }>
                <Image
                  urlOnServer={'/imgs/expand2.png'} 
                  style={{width: 20, height: 20}}
                />
               
              </TouchableOpacity>




          </View>


        </View>


      )
  }

  
}

export default DrawingOptions;
